export * from './seq-view.component';
